/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Manager_Top_CustomersInputs */

const vi_dashboard_manager_top_customers = /** @type {(inputs: Dashboard_Manager_Top_CustomersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top 5 khách hàng`)
};

/**

* @param {Dashboard_Manager_Top_CustomersInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_manager_top_customers = /** @type {((inputs?: Dashboard_Manager_Top_CustomersInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Manager_Top_CustomersInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_manager_top_customers(inputs)
});